/**
 * Moduł notyfikacji
 *
 * @export
 * @class NotificationModule
 */
export class NotificationModule {
  /**
   * Domyślny stan modułu
   *
   * @private
   * @memberof NotificationModule
   */
  private defaultState = {
    show: false,
    current: {
      message: { title: '', messages: [] },
      color: ''
    }
  };

  /**
   * Stan modułu
   *
   * @memberof NotificationModule
   */
  public state = {
    ...this.defaultState,
    current: {
      ...this.defaultState.current
    },
    queue: []
  };

  public mutations = {
    /**
     * Ukrywa notyfikację
     *
     * @param localState stan lokalny
     */
    hideNotification: (localState: any): void => {
      localState.show = this.defaultState.show;
      localState.current = this.defaultState.current;
    },
    /**
     * Pokazuje notyfikację
     *
     * @param localState stan lokalny
     * @param message notyfikacja
     */
    showMessage(localState: any, message: any): void {
      localState.current.message = message.message;
      localState.current.color = message.color || 'black';

      localState.show = true;
    },
    /**
     * Dodaje notyfikację do kolejki
     *
     * @param localState stan lokalny
     * @param message notyfikacja
     */
    addMessage(localState: any, message: any): void {
      localState.queue.push(message);
    },
    /**
     * Usuwa wiadomość z kolejki
     *
     * @param {*} localState
     */
    popMessage(localState: any, index: number): void {
      if (!index) {
        localState.queue.shift();
      } else {
        localState.queue.splice(index, 1);
      }
    },
    /**
     * Czyści kolejkę notyfikacji
     *
     * @param localState stan lokalny
     */
    clearQueue(localState: any): void {
      localState.queue.splice(0, localState.queue.length);
    }
  };

  public actions = {
    /**
     * Wyświetla notyfikację o błędzie
     *
     * @param context context
     * @param text tekst notyfikacji
     */
    notifyError(context: any, msg: object): void {
      context.dispatch('notify', { color: 'error', message: msg });
    },
    /**
     * Wyświetla wiadomość o sukcesie
     * @param context context
     * @param text tekst notyfikacji
     */
    notifySuccess(context: any, msg: object): void {
      context.dispatch('notify', { color: 'success', message: msg });
    },
    /**
     * Wyświetla notyfikację
     *
     * @param context context
     * @param obj notyfikacja
     */
    notify(context: any, obj: any): void {
      context.commit('addMessage', { ...obj, uid: Date.now() + Math.floor(Math.random() * 100000) });
    },
    /**
     * Ukrywa notyfikację
     *
     * @param context context
     */
    hideNotification(context: any, index: number): void {
      context.commit('popMessage', index);
    },
    /**
     * Ukrywa notyfikacje
     *
     * @param context context
     */
    clearAll(context: any): void {
      context.commit('clearQueue');
    }
  };

  public getters = {
    /**
     * Pobiera liczbę notyfikacji w kolejce
     */
    countMessages: (localState: any): number => localState.queue.length,
    /**
     * Pobiera tablice notyfikacji w kolejce
     */
    queueMessages: (localState: any): any[] => localState.queue
  };
}

export default new NotificationModule();
